<template>
  <article class="car_info">
    <h2 class="title">选择车型</h2>
    <div v-for="(series, index) in seriesList" :key="index">
      <span class="title_lab"><label>{{series[0].manufacturer}}</label></span>
      <ul class="car_brand_detail">
        <li v-for="item in series" :key="item.id">
          <a href="javascript:void(0);" @click.stop="selModel(item.id)" class="info">{{item.name}}</a>
        </li>
      </ul>
    </div>
  </article>
</template>
<script>
export default {
  data() {
    return {
      seriesList: []
    }
  },
  created() {
    let brandId = this.$route.params.brandId
    if (brandId) {
      this.$rest.carInfo.getCarBrandList(null, `${brandId}/series`).then((res) => {
        if (res.code === 0) {
          let dataList = {}
          let series = res.series
          series.forEach((v) => {
            if (!dataList[v.manufacturer]) {
              dataList[v.manufacturer] = []
              dataList[v.manufacturer].push({ name: v.name, id: v.id, manufacturer: v.manufacturer })
            } else {
              dataList[v.manufacturer].push({ name: v.name, id: v.id, manufacturer: v.manufacturer })
            }
          })
          this.seriesList = dataList
        } else {
          this.showToast(res.message)
        }
      })
    } else {
      this.showToast('brandId不存在')
    }
  },
  methods: {
    selModel(seriesId) {
      this.$router.push({
        path: '/car/model/' + seriesId
      })
    }
  }
}

</script>
<style scoped lang="less">
@import "../../stylesheets/modules/car/brand.less";
</style>
